import { useDropColumn, useKeepColumn } from "./store";

interface Props {
  fileIds: string[];
  column: string;
}

const KeepDrop = ({ fileIds, column }: Props) => {
  const keepColumn = useKeepColumn(fileIds, column);
  const dropColumn = useDropColumn(fileIds, column);

  return (
    <p className="text-primary-main uppercase text-center">
      <span className="cursor-pointer" onClick={keepColumn}>
        KEEP COLUMN
      </span>{" "}
      |{" "}
      <span className="cursor-pointer" onClick={dropColumn}>
        DROP COLUMN
      </span>
    </p>
  );
};

export default KeepDrop;
